import React, { Component } from "react";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import { getMessage, changeLanguage } from "CONFIG/i18n";
import { isIE } from "react-device-detect";
import moment from 'moment';
import smoothscroll from 'smoothscroll-polyfill';

//DateRangePicker
import 'react-dates/initialize';
import { SingleDatePicker } from 'react-dates';

//components
import Spinner from "COMPONENTS/Spinner/Spinner";
import validator from "validator";
import TimePicker from "COMPONENTS/CommonComponents/TimePicker/TimePicker";
import UserInviteCustomize from "COMPONENTS/SessionManagement/UserInviteCustomize/UserInviteCustomize";

//Stylesheet
import "./ScheduleSession.less";
import 'react-dates/lib/css/_datepicker.css';

import * as rxjs from "rxjs";

import {
  Row,
  Col,
  InputGroup,
  FormControl,
  Modal
} from "react-bootstrap";

//ASSETS
import calendar_img from "ASSETS/Images/Calendar.svg";
import ic_success_modal from "ASSETS/Images/ic_session_scheduled_popup.svg";
import ic_failed_modal from "ASSETS/Images/ic_session_scheduled_popup_Failed.svg";
import icBar from "ASSETS/Images/ic_bar.svg";
import icBack from "ASSETS/Images/back.svg";
import icCalendar from "ASSETS/Images/menu_icons/icon_calendar.svg";

//Utility
import { ERROR, SESSION_TYPE, MODAL_TYPE } from "UTILS/Constants";
import { checkEmpty, separatePhoneNumberAndEmails, getPhoneNumberWithCountryCode, setSMSMessage, checkInvite, getPhoneNumberWithoutCountryCode } from "UTILS/Utility";
import { checkValidTime } from "UTILS/DateUtils";
import { validateMobileNumber } from "UTILS/regexValidations";

//Actions
import { systemAnnouncementAction, organisationAction, scheduleSessionAction } from "CONFIG/ActionFactory";
import modalScrollBar from "../../ModalScrollBar/ModalScrollBar";

class ScheduleSession extends Component {
  constructor(props) {
    super(props);
    this.getInvitees = new rxjs.Subject();
    this.sessionProceed = new rxjs.Subject();
    const editSessionData = this.props.editSessionData;

    let startTime = moment();
    if (startTime.minute() % 15 === 0) {
      startTime.minute(startTime.minute() + 15);
    }
    startTime.minute(Math.ceil(startTime.minute() / 15) * 15);

    const endTime= moment(moment(startTime).add(30, 'm'));
    this.state = {
      sessionKey: editSessionData? editSessionData.sessionKey : "",
      sessionTitle: editSessionData? editSessionData.sessionName : "",
      errorMessage: "",
      errorCode: "",
      inviteeErrorMessage: "",
      inviteeErrorCode: "",
      inviteeInvalid: false,
      isCheckInvite: false,
      isInviteForce: false,
      checkInviteeErrorMessage: "",
      checkInviteMessage: "",
      checkInviteList: [],
      selectedEmail: "",
      selectedPhone: "",
      inviteesList: [],
      currentSessionInvitees: this.props.currentSessionInvitees,
      invitees: editSessionData ? editSessionData.invitees.map(invitee => getPhoneNumberWithoutCountryCode(invitee)).join(',') : "",
      editInviteesList: editSessionData ? editSessionData.invitees : [],
      scheduleDate : editSessionData? moment(editSessionData.scheduledStartTime) : moment(),
      startTime : editSessionData? moment(editSessionData.scheduledStartTime).format("HH:mm") : moment(startTime).format("HH:mm"),
      startTimeError : "", 
      endTime : editSessionData? moment(editSessionData.scheduledEndTime).format("HH:mm") : moment(endTime).format("HH:mm"),
      endTimeError : "",
      scheduleDateError : "",
      sessionType: editSessionData ? SESSION_TYPE.UPDATE_SCHEDULE_MEETING: SESSION_TYPE.SCHEDULE_MEETING,
      showModal: false,
      modalMessage: "",
      modalType: "",
      modalIcon: ic_success_modal,
      closeRecentEmail: true,
      closeRecentPhone: false,
      focused: null,
      dataNotUpdatedErrorMessage:"",
      maxSmsSendMessageError: "",
      isUserInventMsgCustomizeEnable: this.props.userInventMsgCustomize ? this.props.userInventMsgCustomize.isEnable || false : false,
      editInventDetails: null,
    };
    changeLanguage();
  }
  
  handleInputChange = event => {
    this.setState({
      sessionTitle: event.target.value,
      errorMessage:"",
      dataNotUpdatedErrorMessage:"",
    }); 
  };

  handleInviteeInputChange = () => event => {
    this.setState({
      invitees : event.target.value.replace(" ", "").trim(),
      inviteeInvalid: false,
      inviteeErrorMessage: "",
      inviteeErrorCode: "",
      isCheckInvite: false,
      isInviteForce: false,
      checkInviteeErrorMessage: "",
      checkInviteMessage: "",
      checkInviteList: [],
      dataNotUpdatedErrorMessage:"",
      maxSmsSendMessageError: "",
    });
  };

  componentDidMount() {

    smoothscroll.polyfill();

    window.addEventListener('online', () => 
    { 
      let errorMessage = this.state.errorMessage == ERROR.NETWORK_ERROR ? "" : this.state.errorMessage
      this.setState({
        errorMessage: errorMessage
      })
    });
    
    // get active announcements
    systemAnnouncementAction.getActiveAnnouncementsAction().then(
      (response) => {
        this.setState({
          activeAnnouncements: response.data
        })
      },
      error => {
        console.error(error);
      }
    )
    setSMSMessage(this, ["PLEASE_CHOOSE_ANY_GUIDANCE_METHOD_NON_SMS"]);

    organisationAction.getCustomerSmsSendNum().then(
      response => {
        const maxSmsSend = response.data.data.maxSmsSend;
        const smsSendToday = response.data.data.smsSendInfo[0].sms_count;
        const smsSendThisMonth = response.data.data.smsSendInfo[1].sms_count;

        if (this.props.isSMSEnabled && maxSmsSend != 0 && (smsSendToday + smsSendThisMonth >= maxSmsSend)) {
          this.setState({maxSmsSendMessageError: "ERR_MSG_MAX_SMS_SEND" });
        }
      }
    )

    if (this.state.isUserInventMsgCustomizeEnable && this.props.editSessionData) {
      scheduleSessionAction.getInviteDetailsAction(this.state.sessionKey).then(
        response => {
          this.setState({editInventDetails: response.data });
        }
      )
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.currentSessionInvitees !== this.props.currentSessionInvitees) {
      this.setState({
        currentSessionInvitees: this.props.currentSessionInvitees
      });
    }
  }

  isInputValid = () => {
    let startTime = moment(moment(this.state.scheduleDate).format('YYYY/MM/DD') + " " + this.state.startTime, 'YYYY-MM-DD HH:mm').valueOf();
    let endTime= moment(moment(this.state.scheduleDate).format('YYYY/MM/DD') + " " + this.state.endTime, 'YYYY-MM-DD HH:mm').valueOf();
    if (startTime >= endTime) {
      endTime= moment(moment(this.state.scheduleDate).add(1, 'days').format('YYYY/MM/DD') + " " + this.state.endTime, 'YYYY-MM-DD HH:mm').valueOf();
    }
    let startEndTimeDifference = moment(endTime).diff(moment(startTime), 'minutes');
    if (checkEmpty(this.state.sessionTitle.trim())) {
      this.setState({
        errorMessage: "ERR_MSG_SESSION_TITLE"
      });
      window.scrollTo(0, 0);
      return false;
    }
    if(checkEmpty(this.state.scheduleDate)) {
      this.setState({ scheduleDateError: "ERR_MSG_SCHEDULER_DATE" });
      window.scrollTo(0, 0);
      return false;
    } else if(this.state.scheduleDate.diff(moment().subtract(1, 'days').startOf('day'),"days") <= 0){
      this.setState({ scheduleDateError: "ERR_MSG_SCHEDULE_INVALID_DATE" });
      window.scrollTo(0, 0);
      return false;
    } else if(checkValidTime(startTime) || startEndTimeDifference === 1440) {
      this.setState({startTimeError: "ERR_MSG_SCHEDULE_INVALID_TIME" });
      window.scrollTo(0, 0);
      return false;
    } else if(startEndTimeDifference > 480){ //480 minutes = 8 hours
      this.setState({endTimeError: "ERR_MSG_SCHEDULE_MORE_THAN_8_HRS" });
      window.scrollTo(0, 0);
      return false;
    }
    return this.validateAndGetInvitees();
  }

  validateAndGetInvitees = () => {
    if(this.state.invitees && this.state.invitees.trim().length > 0) {
      var separators = [",", ";"];
      let arrayOfInvitees = this.state.invitees.split(
        new RegExp(separators.join("|"), "g")
      );
      let allInvites = [];
      let{ arrayOfEmails, arrayOfPhone } = separatePhoneNumberAndEmails(arrayOfInvitees);

      // validate emails - starts
      for (var i = 0; i < arrayOfEmails.length; i++) {
        let email = arrayOfEmails[i];
        let isValidEmail = validator.isEmail(email);
        if(!isValidEmail) {
          this.setState({
            inviteeInvalid: true,
            inviteeErrorMessage: getMessage("VALID_EMAIL"),
            inviteeErrorCode: "VALID_EMAIL"
          });
          this.showHideSpinner(false);
          return false;
        }
        allInvites.push({email});
      }   // validate emails - ends

      if ((! this.props.isSMSEnabled) && (arrayOfPhone.length != 0)) {
        this.setState({
          inviteeInvalid: true,
          inviteeErrorMessage: getMessage("ERR_MSG_UNABLE_SMS"),
          inviteeErrorCode: "ERR_MSG_UNABLE_SMS"
        });
        return false;
      }

      // validate phone no - starts
      for (var i = 0; i < arrayOfPhone.length; i++) {
        if (arrayOfPhone[i]) {
          let isValidPhone = validateMobileNumber(arrayOfPhone[i]);
          if(!isValidPhone) {
            this.setState({
              inviteeInvalid: true,
              inviteeErrorMessage: getMessage("VALID_PHONE"),
              inviteeErrorCode: "VALID_PHONE"
            });
            this.showHideSpinner(false);
            return false;
          }
          allInvites.push({
            phone: getPhoneNumberWithCountryCode(arrayOfPhone[i]).trim()
          });
        }
      }
      // validate phone no - ends
      this.setState({
        currentSessionInvitees: [...allInvites],
        selectedEmail: "",
        selectedPhone: "",
      });
    } else {
      this.setState({
        currentSessionInvitees: [],
        selectedEmail: "",
        selectedPhone: "",
      });
    }
    return true;
  }

  showHideSpinner = showSpinner => {
    this.setState({
      spinnerVisibility: showSpinner
    })
  }

  enterPressed = event => {
    var code = event.keyCode || event.which;
    if (code === 13) {
      this.scheduleMeeting();
    }
  };

  handleDateChange = (date) => {
    this.setState({
      scheduleDate: date,
      scheduleDateError : ""
    });
  }

  setStartTime = (startTime) => {
    const oldStartTime = moment(moment(this.state.scheduleDate).format('YYYY/MM/DD') + " " + this.state.startTime, 'YYYY-MM-DD HH:mm').valueOf();
    let endTime = moment(moment(this.state.scheduleDate).format('YYYY/MM/DD') + " " + this.state.endTime, 'YYYY-MM-DD HH:mm').valueOf();
    const oldStartEndTimeDiff = moment(endTime).diff(moment(oldStartTime), 'minutes');
    let date= this.state.scheduleDate? moment(this.state.scheduleDate).format('YYYY/MM/DD'): moment().format('YYYY/MM/DD');
    endTime = moment(date+" "+startTime, 'YYYY-MM-DD HH:mm').add(oldStartEndTimeDiff, 'minute').format('HH:mm');
    this.setState({
      startTime,
      endTime,
      startTimeError: "",
      dataNotUpdatedErrorMessage:""
    });
  }

  setEndTime = (endTime) => {
    this.setState({
      endTime,
      endTimeError: "",
      dataNotUpdatedErrorMessage:""
    });
  }

  scheduleMeeting = (customize = null) => {
    const { sessionKey, sessionTitle } = this.state;
    let startTime = moment(moment(this.state.scheduleDate).format('YYYY/MM/DD') + " " + this.state.startTime, 'YYYY-MM-DD HH:mm').valueOf();
    let endTime= moment(moment(this.state.scheduleDate).format('YYYY/MM/DD') + " " + this.state.endTime, 'YYYY-MM-DD HH:mm').valueOf();
    if (startTime >= endTime) {
      endTime= moment(moment(this.state.scheduleDate).add(1, 'days').format('YYYY/MM/DD') + " " + this.state.endTime, 'YYYY-MM-DD HH:mm').valueOf();
    }
    const sessionDetails = {
      sessionKey,
      sessionTitle: sessionTitle.trim(),
      startTime,
      endTime
    }

    var separators = [",", ";"];
    let arrayOfInvitees = this.state.invitees.split(
      new RegExp(separators.join("|"), "g")
    );
    let{ arrayOfEmails, arrayOfPhone } = separatePhoneNumberAndEmails(arrayOfInvitees);

    new Promise((resolve, reject) =>{
      organisationAction.getCustomerSmsSendNum().then(
        response => {
          let smsSendCheckResult = false;
          const maxSmsSend = response.data.data.maxSmsSend;
          const smsSendToday = response.data.data.smsSendInfo[0].sms_count;
          const smsSendThisMonth = response.data.data.smsSendInfo[1].sms_count;

          if (arrayOfPhone.length!=0 && arrayOfPhone[0] != '') {
            if (this.props.isSMSEnabled && maxSmsSend != 0 && (arrayOfPhone.length + smsSendToday + smsSendThisMonth > maxSmsSend)) {
              this.setState({maxSmsSendMessageError: "ERR_MSG_MAX_SMS_SEND" });
              let proceedBtn = document.getElementById("proceedBtn");
              proceedBtn.disabled = false;
            } else {
              smsSendCheckResult = true;
            }
          } else {
            smsSendCheckResult = true;
          }
    
          if (smsSendCheckResult && this.isInputValid()) {
            this.setState({
              errorMessage: ""
            }, async() => {
              this.showHideSpinner(true);

              if (!this.state.isInviteForce) {
                const resultCheckInvite = await checkInvite(this.state.currentSessionInvitees);
                if (resultCheckInvite) {
                  this.setState({
                    isCheckInvite: true,
                    checkInviteeErrorMessage: getMessage("INVITATION_CHECK_ERROR"),
                    checkInviteList: resultCheckInvite
                  });
                  this.showHideSpinner(false);
                  return;
                }
              }

              if(this.state.sessionType === SESSION_TYPE.SCHEDULE_MEETING) {
                this.props.scheduleMeeting(
                  this.state.currentSessionInvitees,
                  sessionDetails, 
                  this.onSessionScheduleSuccessHandler,
                  this.onSessionScheduleFailureHandler,
                  customize,
                );
              } else {
                let isUpdated = false;
                if(this.props.editSessionData.sessionKey != sessionDetails.sessionKey
                  || this.props.editSessionData.sessionName != sessionDetails.sessionTitle
                  || this.props.editSessionData.scheduledStartTime != sessionDetails.startTime
                  || this.props.editSessionData.scheduledEndTime != sessionDetails.endTime
                  || (this.state.invitees != this.props.editSessionData.invitees
                    || (this.state.invitees && !_.isEqual(this.state.invitees.split(","), this.props.editSessionData.invitees)))
                ) {
                  isUpdated = true;
                }
                if (!isUpdated && this.state.isUserInventMsgCustomizeEnable && this.state.invitees) {
                  const separators = [",", ";"];
                  const arrayOfInvitees = this.state.invitees.split(
                    new RegExp(separators.join("|"), "g")
                  );
                  const { arrayOfEmails, arrayOfPhone } = separatePhoneNumberAndEmails(arrayOfInvitees);
                  if (arrayOfEmails.length > 0) {
                    const editInventDetailsEmailObj = Object.keys(this.state.editInventDetails).length !== 0 ? this.state.editInventDetails.email : {};
                    const customizeEmailObj = customize ? customize.email : {};
                    if (editInventDetailsEmailObj.from != customizeEmailObj.from
                      || editInventDetailsEmailObj.subject != customizeEmailObj.subject
                      || editInventDetailsEmailObj.message != customizeEmailObj.message
                    ) {
                      isUpdated = true;
                    }
                  }
                  if (arrayOfPhone.length > 0) {
                    const editInventDetailsSmsObj = Object.keys(this.state.editInventDetails).length !== 0 ? this.state.editInventDetails.phone : {};
                    const customizeSmsObj = customize ? customize.phone :{};
                    if (editInventDetailsSmsObj.message != customizeSmsObj.message) {
                      isUpdated = true;
                    }
                  }
                }
                if (isUpdated) {
                  this.props.updateMeeting(
                    this.state.currentSessionInvitees,
                    sessionDetails, 
                    this.onSessionScheduleSuccessHandler,
                    this.onSessionScheduleFailureHandler,
                    customize,
                  );
                } else {
                  this.setState({
                    dataNotUpdatedErrorMessage: "DETAILS_NOT_UPDATED",
                    checkInviteeErrorMessage: "",
                    checkInviteMessage: "",
                    checkInviteList: [],
                  })
                  this.showHideSpinner(false);
                }
              }
            });
          }
        }
      )
    });
  }

  handleScheduleMeetingCustomize = (emailToAddresses, smsToNumber, customize) => {
    let invitees = emailToAddresses + ',' + smsToNumber;
    invitees = invitees.replace(/^,/, '');
    invitees = invitees.replace(/,$/, '');
    this.setState({
      invitees,
      isInviteForce: this.state.isCheckInvite ? true : false,
    });
    setTimeout(() => {
      this.scheduleMeeting(customize);
    }, 100);
  }

  resetStateData = () => {
    this.showHideSpinner(false);
    this.setState({ 
      sessionType: SESSION_TYPE.SCHEDULE_MEETING,
      sessionTitle: "",
      inviteesList: [],
      scheduleDate: moment(),
      currentSessionInvitees: [],
      startTime: "",
      endTime: "",
      invitees: "",
      displayInvities: false,
      endTimeError: ""
    });
  }

  onSessionScheduleSuccessHandler = (res) => {
    this.showHideSpinner(false);
    this.setState({ 
      modalType: MODAL_TYPE.SUCCESS, 
      modalMessage: this.state.sessionType === SESSION_TYPE.SCHEDULE_MEETING?
        getMessage("SCHEDULE_SUCCESS_MESSAGE") : getMessage("UPDATE_SESSION_SUCCESS_MESSAGE") ,
      modalIcon: ic_success_modal,
      sessionType: SESSION_TYPE.SCHEDULE_MEETING,
      sessionTitle: "",
      inviteesList: [],
      scheduleDate: moment(),
      currentSessionInvitees: [],
      invitees: "",
      scheduleDateError: "",
      startTimeError: "",
      endTimeError: "",
      displayInvities: false
    },()=>{
      this.setState({showModal: true})
    })
  }

  onSessionScheduleFailureHandler = (errorCode) =>{
    this.showHideSpinner(false);
    errorCode &&
    this.setState({
      modalType: MODAL_TYPE.FAILURE, 
      modalMessage: getMessage(errorCode),
      modalIcon: ic_failed_modal, 
    },()=>{
      this.setState({showModal: true})
    })
  }

  toggleModal = () => {
    const modalType = this.state.modalType;
    this.setState({
      showModal : !this.state.showModal,
      modalType: "", 
      modalMessage: "",
      modalIcon: "",
    })
    if (modalType === MODAL_TYPE.SUCCESS) {
      this.backYesHandle();
    }
  }

  componentWillUnmount() {
    let proceedBtn = document.getElementById("proceedBtn");
    proceedBtn.disabled = false;
  }

  testEmail = () => {
    return this.state.selectedEmail.includes(',') ? this.state.selectedEmail : "";
  }

  testNumber = () => {
    let isCommaPresent = this.state.selectedPhone.includes(',');
    if(isCommaPresent) {
      return this.state.selectedPhone;
    }
    return "";
  }

  backYesHandle = () =>{
    this.props.backToMenu();
  }

  showCheckInvite = () => {
    let checkInviteMessage = [];
    this.state.checkInviteList.forEach((participant, index) => {
      const email = participant.split('@');
      checkInviteMessage.push(<>{email[0] + "@"}<span className="checkInvite">{email[1]}</span></>);
      if (this.state.checkInviteList.length - 1 > index) {
        checkInviteMessage.push(<>{", "}</>);
      }
    })
    return (
      <>{checkInviteMessage}</>
    );
  }

  renderUserInviteDefault() {
    return (
      <div>
        { this.state.isUserInventMsgCustomizeEnable &&
          <span className="message mt-2 pb-2">
            {getMessage(this.state.PleaseChooseAnyGuidanceMethodMsg)}
          </span>
        }
        <input
          type="text"
          className="formControlName border w-100 form-control"
          onChange={this.handleInviteeInputChange()}
          value={this.state.invitees}
          placeholder= {getMessage("INVITE_INPUT_PLACEHOLDER")}
          style={{width: "100%"}}
        />
        {(!this.state.isCheckInvite) ?
          <Row className="d-flex justify-content-center errors my-0 py-2">
            {this.state.inviteeErrorCode === "PROPS"
              ? this.state.inviteeErrorMessage
              : getMessage(this.state.inviteeErrorCode)}
          </Row> :
          <>
            <Col className="errors text-center error-message">
              {this.state.checkInviteeErrorMessage}
            </Col>
            <Col className="errors text-center error-message">
              {this.showCheckInvite()}
            </Col>
          </>
        }
        <div className="errors autoHeight">{getMessage(this.state.maxSmsSendMessageError)}</div>
        <div className="d-flex justify-content-center">
          <Col sm={6} xl={4}>
            <div className="errors autoHeight">{getMessage(this.state.dataNotUpdatedErrorMessage)}</div>
            <button
              id="proceedBtn"
              className="startBtn btn shadow-none rounded-pill w-100 whiteOnClick py-2"
              onClick={() => {
                this.state.isInviteForce = this.state.isCheckInvite ? true : false;
                this.scheduleMeeting();
              }}
            >
              {getMessage("SCHEDULE_MEETING_BUTTON")}
            </button>
          </Col>
        </div>
      </div>
    )
  }

  handleUserInviteCustomizeTabSelect = (index) => {
    // INVITE_MSG_DEFAULT_TAB selected
    if (index == 1) {
      this.setState({
        invitees: this.props.editSessionData ? this.props.editSessionData.invitees.join(',') : "",
      })
    };
  }

  renderUserInviteCustomizeTab() {
    return (
      <div>
        <Tabs
          onSelect={this.handleUserInviteCustomizeTabSelect}
          selectedIndex={this.state.selectedUserInventMsgCustomizeTadIndex}
        >
          <TabList>
            <Tab>{getMessage("INVITE_MSG_CUSTOMIZE_TAB")}</Tab>
            <Tab>{getMessage("INVITE_MSG_DEFAULT_TAB")}</Tab>
          </TabList>

          <TabPanel>
            <UserInviteCustomize
              language={this.props.language}
              editSessionData={this.props.editSessionData}
              editInventDetails={this.state.editInventDetails}
              isSMSEnabled={this.props.isSMSEnabled}
              userInventMsgCustomize={this.props.userInventMsgCustomize}
              userProfileData={this.props.userProfileData}
              isCheckInvite={this.state.isCheckInvite}
              inviteeErrorCode={this.state.inviteeErrorCode}
              inviteeErrorMessage={this.state.inviteeErrorMessage}
              checkInviteeErrorMessage={this.state.checkInviteeErrorMessage}
              isInviteForce={this.state.isInviteForce}
              maxSmsSendMessageError={this.state.maxSmsSendMessageError}
              dataNotUpdatedErrorMessage={this.state.dataNotUpdatedErrorMessage}
              userName={this.props.userName}
              showCheckInvite={this.showCheckInvite}
              handleScheduleMeeting={this.handleScheduleMeetingCustomize}
              isSchedule={true}
            />
          </TabPanel>
          <TabPanel>
            {this.renderUserInviteDefault()}
          </TabPanel>
        </Tabs>
      </div>
    )
  }

  render() {
    const calenderNode = (<img src={calendar_img}/>)
    return (
      <div className="scheduleSession">
        {/*show spinner when update , schedule and proceed request initiated*/}
        {this.state.spinnerVisibility && <Spinner showSpinner={this.state.spinnerVisibility} />}

        {/*modal popup for the success and failure*/}
        <Modal show={this.state.showModal} className="scheduleSessionModal" centered>
          <div className="p-3">
            <div className="d-flex justify-content-center">
              <img src={this.state.modalIcon}/>
            </div>
            <div className = {
              this.state.modalType === MODAL_TYPE.SUCCESS ?
                "d-flex justify-content-center p-3 modalMessage" : 
                "d-flex justify-content-center p-3 failureModalMessage"
            }
            >{this.state.modalMessage}</div> 
            <div className="d-flex justify-content-center p-3">
              <div className="col-md-5"><button className = {
                this.state.modalType === MODAL_TYPE.SUCCESS ?
                  "btn w-100 rounded-pill modalBtn whiteOnClick" : 
                  "btn w-100 rounded-pill modalBtnFailure whiteOnClick" }
              onClick={this.toggleModal}>{getMessage("OK")}</button></div>
            </div>
          </div>
        </Modal>

        <section>
          <div className="container-fluid">
            <div className="col-xl-2 col-12 d-flex align-items-center pt-2 backBtn pl-0" >
              <img src={icBack} className="pr-2 cursorPointer" onClick={this.backYesHandle}/>
              <span className="cursorPointer" onClick={this.backYesHandle}>{getMessage("BACK_TO_MENU")}</span>
            </div>
            <div className="container">
              <div className="col-12 col-xl-6 offset-xl-3 d-flex justify-content-center">
                <div className="col-5 col-sm-3 p-0 d-flex flex-column">
                  <Row>
                    <Col md={12} className="text-center">
                      <img
                        src={icCalendar}
                        className="img-fluid session-img createSessionImage"
                        alt="Start Session"
                      />
                    </Col>
                  </Row>
                </div>
              </div>
              <Row>
                <Col md={12} className="text-center pb-4">
                  <span className="sessionMenuTitle">
                    {this.state.sessionType === SESSION_TYPE.SCHEDULE_MEETING ?
                      getMessage("CREATE_MEETING_APPOINTMENT") 
                      : getMessage("UPDATE_MEETING_APPOINTMENT")}
                  </span>
                </Col>
              </Row>
              <div className="d-flex justify-content-center pt-2">
                <div className="col-12 col-xl-9 px-0">
                  <span className="title">{getMessage("MEETING_SETTINGS")}</span> 
                  <span className="px-3 message">{getMessage("SCHEDULE_MEETING_MESSAGE")}</span>
                </div>
              </div>
              <div className="d-flex justify-content-center pt-2 startSession">
                <div className="col-12 col-xl-9 inputForm flexDirectionColumn px-4 pt-4" id="inviteeScrollView">
                  <label className="labelStyle">
                    <img src={icBar} className="mr-2 pb-2"/>
                    {getMessage("MEETING_TITLE")}
                    <span className="requireBadge">
                      {getMessage("REQUIRED_BADGE")}
                    </span>
                  </label>
                  <InputGroup>
                    <FormControl
                      type="text"
                      onChange={this.handleInputChange}
                      value={this.state.sessionTitle}
                      placeholder={getMessage("ENTER_SESSION_NAME")}
                      aria-label="Enter name"
                      aria-describedby="basic-addon2"
                      className="formControlName border"
                      maxLength={25}
                      onKeyPress={this.enterPressed}
                      autoFocus={isIE ? false : true}
                    />
                  </InputGroup>
                  <div className="errors autoHeight">{getMessage(this.state.errorMessage)}</div>
                  <div className="row px-3 mt-2">
                    <label className="labelStyle">
                      <img src={icBar} className="pr-2"/>
                      {getMessage("SCHEDULE_MESSAGE")}
                      <span className="requireBadge">
                        {getMessage("REQUIRED_BADGE")}
                      </span>
                    </label>
                  </div>
                  <div className="row">
                    <div className="col-lg-5 col-md-5 col-sm-12 col-xs-12 iconContainer">
                      <SingleDatePicker
                        date={this.state.scheduleDate} 
                        onDateChange={date => this.setState({ scheduleDate: date, scheduleDateError : "", dataNotUpdatedErrorMessage:""})} 
                        focused={this.state.focused}
                        onFocusChange={({ focused }) => this.setState({ focused })} 
                        numberOfMonths={1}
                        id="scheduleDate"
                        showDefaultInputIcon={true}
                        inputIconPosition="after"
                        customInputIcon={calenderNode}
                        displayFormat="YYYY/MM/DD"
                        monthFormat={getMessage("DATE_PICKER_FORMAT")}
                        placeholder={getMessage("DATE_PLACEHOLDER")}
                        verticalSpacing={0}
                        hideKeyboardShortcutsPanel
                      />
                      <div className="errors autoHeight">{getMessage(this.state.scheduleDateError)}</div>
                    </div>

                    <div className="col-lg-3 col-md-3 col-sm-5 col-xs-5 timePickerDiv">
                      <TimePicker
                        setTime={this.setStartTime}
                        value={this.state.startTime}
                        placeholder={getMessage("START_TIME")}
                      />
                      <div className="errors autoHeight">{getMessage(this.state.startTimeError)}</div>
                    </div>
                    <div className="col-lg-1 col-md-1 col-sm-2 col-xs-2 text-center pt-2 justify-content-center labelStyle totext">
                      {getMessage("~")}
                    </div>
                    <div className="col-lg-3 col-md-3 col-sm-5 col-xs-5 timePickerDiv">
                      <TimePicker
                        setTime={this.setEndTime}
                        value={this.state.endTime}
                        placeholder={getMessage("END_TIME")}
                      />
                      <div className="errors autoHeight pb-2">{getMessage(this.state.endTimeError)}</div>
                    </div>
                  </div>
                </div>
              </div> 
              <div className="d-flex justify-content-center">
                <div className="col-12 col-xl-9 px-0">
                  <span className="title">{getMessage("HOW_TO_CONTACT_CUSTOMERS")}</span> 
                  { !this.state.isUserInventMsgCustomizeEnable &&
                    <span className="px-3 message">
                      {getMessage(this.state.PleaseChooseAnyGuidanceMethodMsg)}
                    </span>
                  }
                </div>
              </div>
              <div className="d-flex justify-content-center startSession">
                <div className="col-12 col-xl-9 inputForm flexDirectionColumn p-4" id="inviteeCustom">
                  { this.state.isUserInventMsgCustomizeEnable
                    ? this.renderUserInviteCustomizeTab()
                    : this.renderUserInviteDefault()
                  }
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default modalScrollBar(ScheduleSession);
